import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapSearchItemType',
})
export class MapSearchItemTypePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    let localValue: string = value;
    value = value?.toLocaleLowerCase();
    if (
      [
        'street',
        'square',
        'dehestan',
        'neighbourhood',
        'freeway',
        'highway',
        'tunnel',
        'city',
        'province',
        'park',
        'boulevard',
        'county',
      ].includes(value)
    )
      localValue = 'common.' + value;
    if (['point', 'area'].includes(value)) localValue = '';
    return localValue || '';
  }
}
